import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../common/components";
import './filter-options-text.scss';

const ExpectedResponseFilter: any = (
  props: any
) => {
  const { expectedResponse, handleExpectedResponseChange, isExpectedResponseEnabled, expectedResponseError } = props;

  useEffect(() => {
    if (!isExpectedResponseEnabled) {
      handleExpectedResponseChange({ target: { value: "", name: "expectedResponse" } } as any, "expectedResponse");
    }
  }, [isExpectedResponseEnabled]);

  return (
    <div className="filter-options-text-wrapper">
      <Formik
        initialValues={{
          expectedResponse: expectedResponse,
        }}
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="filter-options">
          <TextInputComponent
            type="text"
            fieldName="expectedResponse"
            placeholder="Enter Expected Response"
            optional={false}
            disabled={false}
            value={expectedResponse}
            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleExpectedResponseChange(e, "expectedResponse")
            }
          />
          {expectedResponseError && <div className="error-text">{expectedResponseError}</div>}
        </Form>
      </Formik>
    </div>
  );
};

export default ExpectedResponseFilter;
